export type ProprietaireStatut = "actif" | "inactif";

export interface Proprietaire {
  id: string;
  prenom: string;
  nom: string;
  telephone: string;
  /** Numéro WhatsApp (facultatif) — prépare les futures relances WhatsApp. */
  whatsapp: string;
  email: string;
  adresse: string;
  notes: string;
  statut: ProprietaireStatut;
  createdAt: string;
}

export type ProprietaireInput = Omit<Proprietaire, "id" | "createdAt">;

export const PROPRIETAIRE_STATUT_LABELS: Record<ProprietaireStatut, string> = {
  actif: "Actif",
  inactif: "Inactif",
};

export const PROPRIETAIRE_STATUT_OPTIONS = [
  { value: "actif", label: "Actif" },
  { value: "inactif", label: "Inactif" },
];

export function proprietaireNomComplet(proprietaire: Proprietaire): string {
  return `${proprietaire.prenom} ${proprietaire.nom}`.trim();
}